export const BANNER_ID = 'build-update-banner'

export function showUpdateBanner() {
  // Prevent duplicate banners
  if (document.getElementById(BANNER_ID)) {
    return
  }

  const banner = document.createElement('div')
  banner.id = BANNER_ID
  banner.setAttribute('role', 'status')
  banner.setAttribute('aria-live', 'polite')

  // Inline styles — independent of project CSS
  Object.assign(banner.style, {
    position: 'fixed',
    bottom: '0',
    left: '0',
    right: '0',
    backgroundColor: '#333',
    color: '#fff',
    padding: '12px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    zIndex: '99999',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: '14px',
  })

  const message = document.createElement('span')
  message.textContent = 'Le site a été mis à jour.'

  const refreshBtn = document.createElement('button')
  refreshBtn.textContent = 'Actualiser'
  Object.assign(refreshBtn.style, {
    backgroundColor: '#e3006a',
    color: '#fff',
    border: 'none',
    padding: '6px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  })
  refreshBtn.addEventListener('click', () => {
    window.location.reload()
  })

  const closeBtn = document.createElement('button')
  closeBtn.setAttribute('aria-label', 'Fermer')
  closeBtn.textContent = '\u00D7'
  Object.assign(closeBtn.style, {
    backgroundColor: 'transparent',
    color: '#fff',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    padding: '0 4px',
    lineHeight: '1',
  })
  closeBtn.addEventListener('click', () => {
    banner.remove()
  })

  banner.appendChild(message)
  banner.appendChild(refreshBtn)
  banner.appendChild(closeBtn)
  document.body.appendChild(banner)
}
